<template>
  <div>
    <page-header>
      <div class="text-nowrap c-black ml-3 mr-3" style="color: black">
        <h4 class="form-check-label">General Settings</h4>
      </div>

      <div class="badgebutton active text-nowrap c-white ml-4">
        <router-link class="ml-1 mt-3 mb-2" :to="{ name: 'Boards' }">
          <i class="far fa-caret-left"></i>
          Back to Landing Page
        </router-link>
      </div>
    </page-header>

    <div class="container-fluid p-3">
      <div class="d-flex">
        <div class="settingsmenu bg-white rounded-left shadow-sm mt-2 mb-2">
          <router-link
            v-if="isGeneralLabelsIsAvailable"
            tag="div"
            class="menuitem"
            :class="{ active: $route.name === routes.labels.generalLabels.name }"
            :to="{
              name: routes.labels.generalLabels.name,
            }"
          >
            <i class="far fa-tags"></i>
            <div class="nav-item-title">General Labels</div>
          </router-link>

          <router-link
            v-if="isMaterialRequestEmailsAvailable"
            tag="div"
            class="menuitem"
            :class="{ active: $route.name === routes.generalSettings.materialRequest.name }"
            :to="{
              name: routes.generalSettings.materialRequest.name,
            }"
          >
            <i class="fa fa-sitemap"></i>
            <div class="nav-item-title">{{ routes.generalSettings.materialRequest.name }}</div>
          </router-link>
        </div>

        <div class="bg-lightgray rounded-sm flex-grow-1 p-4 pl-5 pt-4 shadow-sm settingscontainer shadow-sm">
          <div style="min-width: 800px; max-width: 1550px">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import PageHeader from '@/components/PageHeader.vue';
  import BoardsLabels from '@/components/BoardsSettings/BoardsLabels.vue';
  import RouteNames from '@/types/routeNames';
  import { UserModule, UserStore } from '@/store/user';
  import MaterialRequestService from '@/services/materialRequest.service';

  @Component({
    components: {
      PageHeader,
      BoardsLabels,
    },
  })
  export default class BoardsSettings extends Vue {
    private userStore: UserModule = UserStore;
    routes = RouteNames;

    mounted() {
      if (!this.userStore.user) {
        this.$router.push({ name: RouteNames.boards });
      }
    }

    get isGeneralLabelsIsAvailable() {
      return this.userStore.user.isAdmin || this.userStore.user.isSuperAdmin;
    }

    get isMaterialRequestEmailsAvailable() {
      return MaterialRequestService.isMaterialRequestEmailsAvailable(this.userStore.user);
    }
  }
</script>
